import { useState } from "react"
import { toast } from "react-toastify"
import { addEditDataAPI } from "services/CRUDServices"

export function usePayment(paymentData, refreshTable, setIsOpen, isOpen) {
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingPos, setIsLoadingPos] = useState(false)

  const [time, setTime] = useState(0)

  const handleClick = () => {
    setIsLoadingPos(true)
    setTime(60)
    toast.info("لطفا کارت را بکشید")
    addEditDataAPI(`/consignment-api/bankReceipt/callPos`, "post", {
      ...paymentData,
    })
      .then((res) => {
        setTime(0)
        toast.success("پرداخت با موفقیت انجام شد")
        refreshTable()
        setIsOpen({ ...isOpen, posModal: false })
      })
      .catch(() => {
        setIsLoadingPos(false)
        setTime(0)
      })
  }
  return {
    isLoading,
    isLoadingPos,
    setIsLoading,
    setIsLoadingPos,
    handleClick,
    time,
  }
}
